/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { TeamScope, teamScopeFromJSON, teamScopeToJSON, teamScopeToNumber } from "./scopes";

export const protobufPackage = "protos.permissions.v2";

export enum TeamRole {
  UNSPECIFIED = "TEAM_ROLE_UNSPECIFIED",
  MEMBER = "TEAM_ROLE_MEMBER",
  MANAGER = "TEAM_ROLE_MANAGER",
}

export function teamRoleFromJSON(object: any): TeamRole {
  switch (object) {
    case 0:
    case "TEAM_ROLE_UNSPECIFIED":
      return TeamRole.UNSPECIFIED;
    case 10:
    case "TEAM_ROLE_MEMBER":
      return TeamRole.MEMBER;
    case 20:
    case "TEAM_ROLE_MANAGER":
      return TeamRole.MANAGER;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum TeamRole");
  }
}

export function teamRoleToJSON(object: TeamRole): string {
  switch (object) {
    case TeamRole.UNSPECIFIED:
      return "TEAM_ROLE_UNSPECIFIED";
    case TeamRole.MEMBER:
      return "TEAM_ROLE_MEMBER";
    case TeamRole.MANAGER:
      return "TEAM_ROLE_MANAGER";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum TeamRole");
  }
}

export function teamRoleToNumber(object: TeamRole): number {
  switch (object) {
    case TeamRole.UNSPECIFIED:
      return 0;
    case TeamRole.MEMBER:
      return 10;
    case TeamRole.MANAGER:
      return 20;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum TeamRole");
  }
}

/** The operation to be used to update team membership */
export enum UpdateAction {
  UNSPECIFIED = "UPDATE_ACTION_UNSPECIFIED",
  /** ADD - Add the given entity to the team */
  ADD = "UPDATE_ACTION_ADD",
  /** UPDATE - Update information associated with the given entity (e.g. their role) in the team */
  UPDATE = "UPDATE_ACTION_UPDATE",
  /** REMOVE - Remove the given entity from the team */
  REMOVE = "UPDATE_ACTION_REMOVE",
}

export function updateActionFromJSON(object: any): UpdateAction {
  switch (object) {
    case 0:
    case "UPDATE_ACTION_UNSPECIFIED":
      return UpdateAction.UNSPECIFIED;
    case 1:
    case "UPDATE_ACTION_ADD":
      return UpdateAction.ADD;
    case 2:
    case "UPDATE_ACTION_UPDATE":
      return UpdateAction.UPDATE;
    case 3:
    case "UPDATE_ACTION_REMOVE":
      return UpdateAction.REMOVE;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum UpdateAction");
  }
}

export function updateActionToJSON(object: UpdateAction): string {
  switch (object) {
    case UpdateAction.UNSPECIFIED:
      return "UPDATE_ACTION_UNSPECIFIED";
    case UpdateAction.ADD:
      return "UPDATE_ACTION_ADD";
    case UpdateAction.UPDATE:
      return "UPDATE_ACTION_UPDATE";
    case UpdateAction.REMOVE:
      return "UPDATE_ACTION_REMOVE";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum UpdateAction");
  }
}

export function updateActionToNumber(object: UpdateAction): number {
  switch (object) {
    case UpdateAction.UNSPECIFIED:
      return 0;
    case UpdateAction.ADD:
      return 1;
    case UpdateAction.UPDATE:
      return 2;
    case UpdateAction.REMOVE:
      return 3;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum UpdateAction");
  }
}

/** A user in a team, with their role */
export interface TeamUser {
  /** The user's ID */
  userId: number;
  /** The user's role in the team */
  role: TeamRole;
}

/** An individual RBAC team */
export interface Team {
  /** The team's ID */
  id: number;
  /** Deployment ID which this team belongs to */
  deploymentId: number;
  /** The team's human-readable name */
  name: string;
  /** The team's machine-friendly slug */
  slug: string;
  /** IDs of repositories that are part of this team */
  repositoryIds: number[];
  /** (user, role) pairs for users that are part of this team */
  users: TeamUser[];
  /** The Team ID of this team's parent team. If unset, the team is an organization-level team. */
  parentTeamId?:
    | number
    | undefined;
  /** The IDs of teams that are nested directly beneath this team (i.e. that have this team as their parent). */
  childTeamIds: number[];
  /** The number of repositories that are part of this team */
  repositoryCount?:
    | number
    | undefined;
  /** The number of users that are part of this team */
  userCount?:
    | number
    | undefined;
  /** The number of teams nested directly beneath this team. */
  childTeamCount?:
    | number
    | undefined;
  /** Whether new projects should automatically be added to this team */
  isProjectDefault?:
    | boolean
    | undefined;
  /** Whether new users should automatically be added to this team */
  isUserDefault?:
    | boolean
    | undefined;
  /** The scopes that the current user is authorized for */
  authorizedScopes: TeamScope[];
}

export interface CheckRbacStatusRequest {
  deploymentId: number;
}

export interface CheckRbacStatusResponse {
  deploymentId: number;
  /** whether RBAC has been enabled for the deployment */
  enabled: boolean;
  /** whether the deployment has self-serve RBAC enablement turned on */
  selfServeEnabled: boolean;
}

export interface SetRbacStatusRequest {
  deploymentId: number;
  enabled: boolean;
  /** whether to configure the newly created team when enabling Rbac as a user-default group. */
  useUserDefaultTeam: boolean;
}

export interface SetRbacStatusResponse {
  deploymentId: number;
  taskToken: string;
}

export interface ListDeploymentTeamsRequest {
  /** Deployment ID for which to list teams */
  deploymentId: number;
}

export interface ListDeploymentTeamsResponse {
  teams: Team[];
}

/** CreateDeploymentTeam */
export interface TeamCreate {
  /** The name of the team to create */
  name: string;
  /** Repository IDs to add to the team */
  repositoryIds: number[];
  /** (user, role) pairs to add to the team */
  users: TeamUser[];
  /** The Team ID under which to nest the new team. If not provided, the team will be an organization-level team. */
  parentTeamId?: number | undefined;
}

export interface CreateDeploymentTeamRequest {
  /** Deployment ID in which to create the team. */
  deploymentId: number;
  /** Details of the team to be created */
  team: TeamCreate | undefined;
}

export interface CreateDeploymentTeamResponse {
  /** Details of the created team */
  team: Team | undefined;
}

export interface GetDeploymentTeamRequest {
  /** Deployment ID of the team to fetch. */
  deploymentId: number;
  /** The ID of the team to fetch */
  teamId: number;
}

export interface GetDeploymentTeamResponse {
  team: Team | undefined;
}

/** An individual change to make to the repositories of a team */
export interface TeamRepositoryAction {
  /** The repository ID to add or remove */
  repositoryId: number;
  /** Whether to add or remove the repository. UPDATE is not supported. */
  action: UpdateAction;
}

/** An individual change to make to the users of a team */
export interface TeamUserAction {
  /** The user's ID */
  userId: number;
  /** The action to take. If the action is UPDATE, the user's role will be updated to the given role. */
  action: UpdateAction;
  /** The user's new or existing role. */
  role: TeamRole;
}

export interface TeamParentTeamIdAction {
  parentTeamId?: number | undefined;
  action: UpdateAction;
}

/** Actions to take to update a team */
export interface TeamUpdate {
  /** The ID of the team to update */
  id: number;
  /** The deployment ID of the team to update */
  deploymentId: number;
  /** Value to change the team's name to. If not specified, the team's name will be unchanged. */
  name?:
    | string
    | undefined;
  /** Repositories to add or remove from the team */
  repositories: TeamRepositoryAction[];
  /** Users to add, remove, or update in the team */
  users: TeamUserAction[];
}

export interface UpdateDeploymentTeamRequest {
  /** Deployment ID of the team to update */
  deploymentId: number;
  /** ID of the team to update */
  teamId: number;
  /** Changes to make to the team */
  team: TeamUpdate | undefined;
}

export interface UpdateDeploymentTeamResponse {
  /** The updated team */
  team: Team | undefined;
}

export interface DeleteDeploymentTeamRequest {
  /** Deployment ID of the team to delete */
  deploymentId: number;
  /** ID of the team to delete */
  teamId: number;
}

export interface DeleteDeploymentTeamResponse {
}

function createBaseTeamUser(): TeamUser {
  return { userId: 0, role: TeamRole.UNSPECIFIED };
}

export const TeamUser = {
  encode(message: TeamUser, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== 0) {
      writer.uint32(8).int64(message.userId);
    }
    if (message.role !== TeamRole.UNSPECIFIED) {
      writer.uint32(16).int32(teamRoleToNumber(message.role));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TeamUser {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.userId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.role = teamRoleFromJSON(reader.int32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamUser {
    return {
      userId: isSet(object.userId) ? Number(object.userId) : 0,
      role: isSet(object.role) ? teamRoleFromJSON(object.role) : TeamRole.UNSPECIFIED,
    };
  },

  toJSON(message: TeamUser): unknown {
    const obj: any = {};
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId);
    }
    if (message.role !== TeamRole.UNSPECIFIED) {
      obj.role = teamRoleToJSON(message.role);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeamUser>, I>>(base?: I): TeamUser {
    return TeamUser.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeamUser>, I>>(object: I): TeamUser {
    const message = createBaseTeamUser();
    message.userId = object.userId ?? 0;
    message.role = object.role ?? TeamRole.UNSPECIFIED;
    return message;
  },
};

function createBaseTeam(): Team {
  return {
    id: 0,
    deploymentId: 0,
    name: "",
    slug: "",
    repositoryIds: [],
    users: [],
    parentTeamId: undefined,
    childTeamIds: [],
    repositoryCount: undefined,
    userCount: undefined,
    childTeamCount: undefined,
    isProjectDefault: undefined,
    isUserDefault: undefined,
    authorizedScopes: [],
  };
}

export const Team = {
  encode(message: Team, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.deploymentId !== 0) {
      writer.uint32(16).int64(message.deploymentId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.slug !== "") {
      writer.uint32(34).string(message.slug);
    }
    writer.uint32(42).fork();
    for (const v of message.repositoryIds) {
      writer.int64(v);
    }
    writer.ldelim();
    for (const v of message.users) {
      TeamUser.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    if (message.parentTeamId !== undefined) {
      writer.uint32(56).int64(message.parentTeamId);
    }
    writer.uint32(66).fork();
    for (const v of message.childTeamIds) {
      writer.int64(v);
    }
    writer.ldelim();
    if (message.repositoryCount !== undefined) {
      writer.uint32(72).int64(message.repositoryCount);
    }
    if (message.userCount !== undefined) {
      writer.uint32(80).int64(message.userCount);
    }
    if (message.childTeamCount !== undefined) {
      writer.uint32(88).int64(message.childTeamCount);
    }
    if (message.isProjectDefault !== undefined) {
      writer.uint32(160).bool(message.isProjectDefault);
    }
    if (message.isUserDefault !== undefined) {
      writer.uint32(168).bool(message.isUserDefault);
    }
    writer.uint32(402).fork();
    for (const v of message.authorizedScopes) {
      writer.int32(teamScopeToNumber(v));
    }
    writer.ldelim();
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Team {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeam();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.slug = reader.string();
          continue;
        case 5:
          if (tag === 40) {
            message.repositoryIds.push(longToNumber(reader.int64() as Long));

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.repositoryIds.push(longToNumber(reader.int64() as Long));
            }

            continue;
          }

          break;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.users.push(TeamUser.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.parentTeamId = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag === 64) {
            message.childTeamIds.push(longToNumber(reader.int64() as Long));

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.childTeamIds.push(longToNumber(reader.int64() as Long));
            }

            continue;
          }

          break;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.repositoryCount = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.userCount = longToNumber(reader.int64() as Long);
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.childTeamCount = longToNumber(reader.int64() as Long);
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.isProjectDefault = reader.bool();
          continue;
        case 21:
          if (tag !== 168) {
            break;
          }

          message.isUserDefault = reader.bool();
          continue;
        case 50:
          if (tag === 400) {
            message.authorizedScopes.push(teamScopeFromJSON(reader.int32()));

            continue;
          }

          if (tag === 402) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.authorizedScopes.push(teamScopeFromJSON(reader.int32()));
            }

            continue;
          }

          break;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Team {
    return {
      id: isSet(object.id) ? Number(object.id) : 0,
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      name: isSet(object.name) ? String(object.name) : "",
      slug: isSet(object.slug) ? String(object.slug) : "",
      repositoryIds: Array.isArray(object?.repositoryIds) ? object.repositoryIds.map((e: any) => Number(e)) : [],
      users: Array.isArray(object?.users) ? object.users.map((e: any) => TeamUser.fromJSON(e)) : [],
      parentTeamId: isSet(object.parentTeamId) ? Number(object.parentTeamId) : undefined,
      childTeamIds: Array.isArray(object?.childTeamIds) ? object.childTeamIds.map((e: any) => Number(e)) : [],
      repositoryCount: isSet(object.repositoryCount) ? Number(object.repositoryCount) : undefined,
      userCount: isSet(object.userCount) ? Number(object.userCount) : undefined,
      childTeamCount: isSet(object.childTeamCount) ? Number(object.childTeamCount) : undefined,
      isProjectDefault: isSet(object.isProjectDefault) ? Boolean(object.isProjectDefault) : undefined,
      isUserDefault: isSet(object.isUserDefault) ? Boolean(object.isUserDefault) : undefined,
      authorizedScopes: Array.isArray(object?.authorizedScopes)
        ? object.authorizedScopes.map((e: any) => teamScopeFromJSON(e))
        : [],
    };
  },

  toJSON(message: Team): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.slug !== "") {
      obj.slug = message.slug;
    }
    if (message.repositoryIds?.length) {
      obj.repositoryIds = message.repositoryIds.map((e) => Math.round(e));
    }
    if (message.users?.length) {
      obj.users = message.users.map((e) => TeamUser.toJSON(e));
    }
    if (message.parentTeamId !== undefined) {
      obj.parentTeamId = Math.round(message.parentTeamId);
    }
    if (message.childTeamIds?.length) {
      obj.childTeamIds = message.childTeamIds.map((e) => Math.round(e));
    }
    if (message.repositoryCount !== undefined) {
      obj.repositoryCount = Math.round(message.repositoryCount);
    }
    if (message.userCount !== undefined) {
      obj.userCount = Math.round(message.userCount);
    }
    if (message.childTeamCount !== undefined) {
      obj.childTeamCount = Math.round(message.childTeamCount);
    }
    if (message.isProjectDefault !== undefined) {
      obj.isProjectDefault = message.isProjectDefault;
    }
    if (message.isUserDefault !== undefined) {
      obj.isUserDefault = message.isUserDefault;
    }
    if (message.authorizedScopes?.length) {
      obj.authorizedScopes = message.authorizedScopes.map((e) => teamScopeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Team>, I>>(base?: I): Team {
    return Team.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Team>, I>>(object: I): Team {
    const message = createBaseTeam();
    message.id = object.id ?? 0;
    message.deploymentId = object.deploymentId ?? 0;
    message.name = object.name ?? "";
    message.slug = object.slug ?? "";
    message.repositoryIds = object.repositoryIds?.map((e) => e) || [];
    message.users = object.users?.map((e) => TeamUser.fromPartial(e)) || [];
    message.parentTeamId = object.parentTeamId ?? undefined;
    message.childTeamIds = object.childTeamIds?.map((e) => e) || [];
    message.repositoryCount = object.repositoryCount ?? undefined;
    message.userCount = object.userCount ?? undefined;
    message.childTeamCount = object.childTeamCount ?? undefined;
    message.isProjectDefault = object.isProjectDefault ?? undefined;
    message.isUserDefault = object.isUserDefault ?? undefined;
    message.authorizedScopes = object.authorizedScopes?.map((e) => e) || [];
    return message;
  },
};

function createBaseCheckRbacStatusRequest(): CheckRbacStatusRequest {
  return { deploymentId: 0 };
}

export const CheckRbacStatusRequest = {
  encode(message: CheckRbacStatusRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CheckRbacStatusRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckRbacStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckRbacStatusRequest {
    return { deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0 };
  },

  toJSON(message: CheckRbacStatusRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckRbacStatusRequest>, I>>(base?: I): CheckRbacStatusRequest {
    return CheckRbacStatusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CheckRbacStatusRequest>, I>>(object: I): CheckRbacStatusRequest {
    const message = createBaseCheckRbacStatusRequest();
    message.deploymentId = object.deploymentId ?? 0;
    return message;
  },
};

function createBaseCheckRbacStatusResponse(): CheckRbacStatusResponse {
  return { deploymentId: 0, enabled: false, selfServeEnabled: false };
}

export const CheckRbacStatusResponse = {
  encode(message: CheckRbacStatusResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    if (message.enabled === true) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.selfServeEnabled === true) {
      writer.uint32(24).bool(message.selfServeEnabled);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CheckRbacStatusResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckRbacStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.selfServeEnabled = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckRbacStatusResponse {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      enabled: isSet(object.enabled) ? Boolean(object.enabled) : false,
      selfServeEnabled: isSet(object.selfServeEnabled) ? Boolean(object.selfServeEnabled) : false,
    };
  },

  toJSON(message: CheckRbacStatusResponse): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.enabled === true) {
      obj.enabled = message.enabled;
    }
    if (message.selfServeEnabled === true) {
      obj.selfServeEnabled = message.selfServeEnabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckRbacStatusResponse>, I>>(base?: I): CheckRbacStatusResponse {
    return CheckRbacStatusResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CheckRbacStatusResponse>, I>>(object: I): CheckRbacStatusResponse {
    const message = createBaseCheckRbacStatusResponse();
    message.deploymentId = object.deploymentId ?? 0;
    message.enabled = object.enabled ?? false;
    message.selfServeEnabled = object.selfServeEnabled ?? false;
    return message;
  },
};

function createBaseSetRbacStatusRequest(): SetRbacStatusRequest {
  return { deploymentId: 0, enabled: false, useUserDefaultTeam: false };
}

export const SetRbacStatusRequest = {
  encode(message: SetRbacStatusRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    if (message.enabled === true) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.useUserDefaultTeam === true) {
      writer.uint32(24).bool(message.useUserDefaultTeam);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetRbacStatusRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRbacStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.useUserDefaultTeam = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetRbacStatusRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      enabled: isSet(object.enabled) ? Boolean(object.enabled) : false,
      useUserDefaultTeam: isSet(object.useUserDefaultTeam) ? Boolean(object.useUserDefaultTeam) : false,
    };
  },

  toJSON(message: SetRbacStatusRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.enabled === true) {
      obj.enabled = message.enabled;
    }
    if (message.useUserDefaultTeam === true) {
      obj.useUserDefaultTeam = message.useUserDefaultTeam;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetRbacStatusRequest>, I>>(base?: I): SetRbacStatusRequest {
    return SetRbacStatusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetRbacStatusRequest>, I>>(object: I): SetRbacStatusRequest {
    const message = createBaseSetRbacStatusRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.enabled = object.enabled ?? false;
    message.useUserDefaultTeam = object.useUserDefaultTeam ?? false;
    return message;
  },
};

function createBaseSetRbacStatusResponse(): SetRbacStatusResponse {
  return { deploymentId: 0, taskToken: "" };
}

export const SetRbacStatusResponse = {
  encode(message: SetRbacStatusResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    if (message.taskToken !== "") {
      writer.uint32(18).string(message.taskToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetRbacStatusResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRbacStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.taskToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetRbacStatusResponse {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      taskToken: isSet(object.taskToken) ? String(object.taskToken) : "",
    };
  },

  toJSON(message: SetRbacStatusResponse): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.taskToken !== "") {
      obj.taskToken = message.taskToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetRbacStatusResponse>, I>>(base?: I): SetRbacStatusResponse {
    return SetRbacStatusResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetRbacStatusResponse>, I>>(object: I): SetRbacStatusResponse {
    const message = createBaseSetRbacStatusResponse();
    message.deploymentId = object.deploymentId ?? 0;
    message.taskToken = object.taskToken ?? "";
    return message;
  },
};

function createBaseListDeploymentTeamsRequest(): ListDeploymentTeamsRequest {
  return { deploymentId: 0 };
}

export const ListDeploymentTeamsRequest = {
  encode(message: ListDeploymentTeamsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ListDeploymentTeamsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListDeploymentTeamsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListDeploymentTeamsRequest {
    return { deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0 };
  },

  toJSON(message: ListDeploymentTeamsRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListDeploymentTeamsRequest>, I>>(base?: I): ListDeploymentTeamsRequest {
    return ListDeploymentTeamsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListDeploymentTeamsRequest>, I>>(object: I): ListDeploymentTeamsRequest {
    const message = createBaseListDeploymentTeamsRequest();
    message.deploymentId = object.deploymentId ?? 0;
    return message;
  },
};

function createBaseListDeploymentTeamsResponse(): ListDeploymentTeamsResponse {
  return { teams: [] };
}

export const ListDeploymentTeamsResponse = {
  encode(message: ListDeploymentTeamsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.teams) {
      Team.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ListDeploymentTeamsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListDeploymentTeamsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.teams.push(Team.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListDeploymentTeamsResponse {
    return { teams: Array.isArray(object?.teams) ? object.teams.map((e: any) => Team.fromJSON(e)) : [] };
  },

  toJSON(message: ListDeploymentTeamsResponse): unknown {
    const obj: any = {};
    if (message.teams?.length) {
      obj.teams = message.teams.map((e) => Team.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListDeploymentTeamsResponse>, I>>(base?: I): ListDeploymentTeamsResponse {
    return ListDeploymentTeamsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListDeploymentTeamsResponse>, I>>(object: I): ListDeploymentTeamsResponse {
    const message = createBaseListDeploymentTeamsResponse();
    message.teams = object.teams?.map((e) => Team.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTeamCreate(): TeamCreate {
  return { name: "", repositoryIds: [], users: [], parentTeamId: undefined };
}

export const TeamCreate = {
  encode(message: TeamCreate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    writer.uint32(18).fork();
    for (const v of message.repositoryIds) {
      writer.int64(v);
    }
    writer.ldelim();
    for (const v of message.users) {
      TeamUser.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.parentTeamId !== undefined) {
      writer.uint32(32).int64(message.parentTeamId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TeamCreate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag === 16) {
            message.repositoryIds.push(longToNumber(reader.int64() as Long));

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.repositoryIds.push(longToNumber(reader.int64() as Long));
            }

            continue;
          }

          break;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.users.push(TeamUser.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.parentTeamId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamCreate {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      repositoryIds: Array.isArray(object?.repositoryIds) ? object.repositoryIds.map((e: any) => Number(e)) : [],
      users: Array.isArray(object?.users) ? object.users.map((e: any) => TeamUser.fromJSON(e)) : [],
      parentTeamId: isSet(object.parentTeamId) ? Number(object.parentTeamId) : undefined,
    };
  },

  toJSON(message: TeamCreate): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.repositoryIds?.length) {
      obj.repositoryIds = message.repositoryIds.map((e) => Math.round(e));
    }
    if (message.users?.length) {
      obj.users = message.users.map((e) => TeamUser.toJSON(e));
    }
    if (message.parentTeamId !== undefined) {
      obj.parentTeamId = Math.round(message.parentTeamId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeamCreate>, I>>(base?: I): TeamCreate {
    return TeamCreate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeamCreate>, I>>(object: I): TeamCreate {
    const message = createBaseTeamCreate();
    message.name = object.name ?? "";
    message.repositoryIds = object.repositoryIds?.map((e) => e) || [];
    message.users = object.users?.map((e) => TeamUser.fromPartial(e)) || [];
    message.parentTeamId = object.parentTeamId ?? undefined;
    return message;
  },
};

function createBaseCreateDeploymentTeamRequest(): CreateDeploymentTeamRequest {
  return { deploymentId: 0, team: undefined };
}

export const CreateDeploymentTeamRequest = {
  encode(message: CreateDeploymentTeamRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    if (message.team !== undefined) {
      TeamCreate.encode(message.team, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateDeploymentTeamRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateDeploymentTeamRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.team = TeamCreate.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateDeploymentTeamRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      team: isSet(object.team) ? TeamCreate.fromJSON(object.team) : undefined,
    };
  },

  toJSON(message: CreateDeploymentTeamRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.team !== undefined) {
      obj.team = TeamCreate.toJSON(message.team);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateDeploymentTeamRequest>, I>>(base?: I): CreateDeploymentTeamRequest {
    return CreateDeploymentTeamRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateDeploymentTeamRequest>, I>>(object: I): CreateDeploymentTeamRequest {
    const message = createBaseCreateDeploymentTeamRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.team = (object.team !== undefined && object.team !== null)
      ? TeamCreate.fromPartial(object.team)
      : undefined;
    return message;
  },
};

function createBaseCreateDeploymentTeamResponse(): CreateDeploymentTeamResponse {
  return { team: undefined };
}

export const CreateDeploymentTeamResponse = {
  encode(message: CreateDeploymentTeamResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.team !== undefined) {
      Team.encode(message.team, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateDeploymentTeamResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateDeploymentTeamResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.team = Team.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateDeploymentTeamResponse {
    return { team: isSet(object.team) ? Team.fromJSON(object.team) : undefined };
  },

  toJSON(message: CreateDeploymentTeamResponse): unknown {
    const obj: any = {};
    if (message.team !== undefined) {
      obj.team = Team.toJSON(message.team);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateDeploymentTeamResponse>, I>>(base?: I): CreateDeploymentTeamResponse {
    return CreateDeploymentTeamResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateDeploymentTeamResponse>, I>>(object: I): CreateDeploymentTeamResponse {
    const message = createBaseCreateDeploymentTeamResponse();
    message.team = (object.team !== undefined && object.team !== null) ? Team.fromPartial(object.team) : undefined;
    return message;
  },
};

function createBaseGetDeploymentTeamRequest(): GetDeploymentTeamRequest {
  return { deploymentId: 0, teamId: 0 };
}

export const GetDeploymentTeamRequest = {
  encode(message: GetDeploymentTeamRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    if (message.teamId !== 0) {
      writer.uint32(16).int64(message.teamId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetDeploymentTeamRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDeploymentTeamRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.teamId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDeploymentTeamRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      teamId: isSet(object.teamId) ? Number(object.teamId) : 0,
    };
  },

  toJSON(message: GetDeploymentTeamRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.teamId !== 0) {
      obj.teamId = Math.round(message.teamId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDeploymentTeamRequest>, I>>(base?: I): GetDeploymentTeamRequest {
    return GetDeploymentTeamRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDeploymentTeamRequest>, I>>(object: I): GetDeploymentTeamRequest {
    const message = createBaseGetDeploymentTeamRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.teamId = object.teamId ?? 0;
    return message;
  },
};

function createBaseGetDeploymentTeamResponse(): GetDeploymentTeamResponse {
  return { team: undefined };
}

export const GetDeploymentTeamResponse = {
  encode(message: GetDeploymentTeamResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.team !== undefined) {
      Team.encode(message.team, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetDeploymentTeamResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDeploymentTeamResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.team = Team.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDeploymentTeamResponse {
    return { team: isSet(object.team) ? Team.fromJSON(object.team) : undefined };
  },

  toJSON(message: GetDeploymentTeamResponse): unknown {
    const obj: any = {};
    if (message.team !== undefined) {
      obj.team = Team.toJSON(message.team);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDeploymentTeamResponse>, I>>(base?: I): GetDeploymentTeamResponse {
    return GetDeploymentTeamResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDeploymentTeamResponse>, I>>(object: I): GetDeploymentTeamResponse {
    const message = createBaseGetDeploymentTeamResponse();
    message.team = (object.team !== undefined && object.team !== null) ? Team.fromPartial(object.team) : undefined;
    return message;
  },
};

function createBaseTeamRepositoryAction(): TeamRepositoryAction {
  return { repositoryId: 0, action: UpdateAction.UNSPECIFIED };
}

export const TeamRepositoryAction = {
  encode(message: TeamRepositoryAction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.repositoryId !== 0) {
      writer.uint32(8).int64(message.repositoryId);
    }
    if (message.action !== UpdateAction.UNSPECIFIED) {
      writer.uint32(16).int32(updateActionToNumber(message.action));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TeamRepositoryAction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamRepositoryAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.repositoryId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.action = updateActionFromJSON(reader.int32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamRepositoryAction {
    return {
      repositoryId: isSet(object.repositoryId) ? Number(object.repositoryId) : 0,
      action: isSet(object.action) ? updateActionFromJSON(object.action) : UpdateAction.UNSPECIFIED,
    };
  },

  toJSON(message: TeamRepositoryAction): unknown {
    const obj: any = {};
    if (message.repositoryId !== 0) {
      obj.repositoryId = Math.round(message.repositoryId);
    }
    if (message.action !== UpdateAction.UNSPECIFIED) {
      obj.action = updateActionToJSON(message.action);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeamRepositoryAction>, I>>(base?: I): TeamRepositoryAction {
    return TeamRepositoryAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeamRepositoryAction>, I>>(object: I): TeamRepositoryAction {
    const message = createBaseTeamRepositoryAction();
    message.repositoryId = object.repositoryId ?? 0;
    message.action = object.action ?? UpdateAction.UNSPECIFIED;
    return message;
  },
};

function createBaseTeamUserAction(): TeamUserAction {
  return { userId: 0, action: UpdateAction.UNSPECIFIED, role: TeamRole.UNSPECIFIED };
}

export const TeamUserAction = {
  encode(message: TeamUserAction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== 0) {
      writer.uint32(8).int64(message.userId);
    }
    if (message.action !== UpdateAction.UNSPECIFIED) {
      writer.uint32(16).int32(updateActionToNumber(message.action));
    }
    if (message.role !== TeamRole.UNSPECIFIED) {
      writer.uint32(24).int32(teamRoleToNumber(message.role));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TeamUserAction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamUserAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.userId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.action = updateActionFromJSON(reader.int32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.role = teamRoleFromJSON(reader.int32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamUserAction {
    return {
      userId: isSet(object.userId) ? Number(object.userId) : 0,
      action: isSet(object.action) ? updateActionFromJSON(object.action) : UpdateAction.UNSPECIFIED,
      role: isSet(object.role) ? teamRoleFromJSON(object.role) : TeamRole.UNSPECIFIED,
    };
  },

  toJSON(message: TeamUserAction): unknown {
    const obj: any = {};
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId);
    }
    if (message.action !== UpdateAction.UNSPECIFIED) {
      obj.action = updateActionToJSON(message.action);
    }
    if (message.role !== TeamRole.UNSPECIFIED) {
      obj.role = teamRoleToJSON(message.role);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeamUserAction>, I>>(base?: I): TeamUserAction {
    return TeamUserAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeamUserAction>, I>>(object: I): TeamUserAction {
    const message = createBaseTeamUserAction();
    message.userId = object.userId ?? 0;
    message.action = object.action ?? UpdateAction.UNSPECIFIED;
    message.role = object.role ?? TeamRole.UNSPECIFIED;
    return message;
  },
};

function createBaseTeamParentTeamIdAction(): TeamParentTeamIdAction {
  return { parentTeamId: undefined, action: UpdateAction.UNSPECIFIED };
}

export const TeamParentTeamIdAction = {
  encode(message: TeamParentTeamIdAction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.parentTeamId !== undefined) {
      writer.uint32(8).int64(message.parentTeamId);
    }
    if (message.action !== UpdateAction.UNSPECIFIED) {
      writer.uint32(16).int32(updateActionToNumber(message.action));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TeamParentTeamIdAction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamParentTeamIdAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.parentTeamId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.action = updateActionFromJSON(reader.int32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamParentTeamIdAction {
    return {
      parentTeamId: isSet(object.parentTeamId) ? Number(object.parentTeamId) : undefined,
      action: isSet(object.action) ? updateActionFromJSON(object.action) : UpdateAction.UNSPECIFIED,
    };
  },

  toJSON(message: TeamParentTeamIdAction): unknown {
    const obj: any = {};
    if (message.parentTeamId !== undefined) {
      obj.parentTeamId = Math.round(message.parentTeamId);
    }
    if (message.action !== UpdateAction.UNSPECIFIED) {
      obj.action = updateActionToJSON(message.action);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeamParentTeamIdAction>, I>>(base?: I): TeamParentTeamIdAction {
    return TeamParentTeamIdAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeamParentTeamIdAction>, I>>(object: I): TeamParentTeamIdAction {
    const message = createBaseTeamParentTeamIdAction();
    message.parentTeamId = object.parentTeamId ?? undefined;
    message.action = object.action ?? UpdateAction.UNSPECIFIED;
    return message;
  },
};

function createBaseTeamUpdate(): TeamUpdate {
  return { id: 0, deploymentId: 0, name: undefined, repositories: [], users: [] };
}

export const TeamUpdate = {
  encode(message: TeamUpdate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.deploymentId !== 0) {
      writer.uint32(16).int64(message.deploymentId);
    }
    if (message.name !== undefined) {
      writer.uint32(26).string(message.name);
    }
    for (const v of message.repositories) {
      TeamRepositoryAction.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.users) {
      TeamUserAction.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TeamUpdate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.repositories.push(TeamRepositoryAction.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.users.push(TeamUserAction.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamUpdate {
    return {
      id: isSet(object.id) ? Number(object.id) : 0,
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      name: isSet(object.name) ? String(object.name) : undefined,
      repositories: Array.isArray(object?.repositories)
        ? object.repositories.map((e: any) => TeamRepositoryAction.fromJSON(e))
        : [],
      users: Array.isArray(object?.users) ? object.users.map((e: any) => TeamUserAction.fromJSON(e)) : [],
    };
  },

  toJSON(message: TeamUpdate): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.repositories?.length) {
      obj.repositories = message.repositories.map((e) => TeamRepositoryAction.toJSON(e));
    }
    if (message.users?.length) {
      obj.users = message.users.map((e) => TeamUserAction.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeamUpdate>, I>>(base?: I): TeamUpdate {
    return TeamUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeamUpdate>, I>>(object: I): TeamUpdate {
    const message = createBaseTeamUpdate();
    message.id = object.id ?? 0;
    message.deploymentId = object.deploymentId ?? 0;
    message.name = object.name ?? undefined;
    message.repositories = object.repositories?.map((e) => TeamRepositoryAction.fromPartial(e)) || [];
    message.users = object.users?.map((e) => TeamUserAction.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateDeploymentTeamRequest(): UpdateDeploymentTeamRequest {
  return { deploymentId: 0, teamId: 0, team: undefined };
}

export const UpdateDeploymentTeamRequest = {
  encode(message: UpdateDeploymentTeamRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    if (message.teamId !== 0) {
      writer.uint32(16).int64(message.teamId);
    }
    if (message.team !== undefined) {
      TeamUpdate.encode(message.team, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateDeploymentTeamRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateDeploymentTeamRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.teamId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.team = TeamUpdate.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateDeploymentTeamRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      teamId: isSet(object.teamId) ? Number(object.teamId) : 0,
      team: isSet(object.team) ? TeamUpdate.fromJSON(object.team) : undefined,
    };
  },

  toJSON(message: UpdateDeploymentTeamRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.teamId !== 0) {
      obj.teamId = Math.round(message.teamId);
    }
    if (message.team !== undefined) {
      obj.team = TeamUpdate.toJSON(message.team);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateDeploymentTeamRequest>, I>>(base?: I): UpdateDeploymentTeamRequest {
    return UpdateDeploymentTeamRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateDeploymentTeamRequest>, I>>(object: I): UpdateDeploymentTeamRequest {
    const message = createBaseUpdateDeploymentTeamRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.teamId = object.teamId ?? 0;
    message.team = (object.team !== undefined && object.team !== null)
      ? TeamUpdate.fromPartial(object.team)
      : undefined;
    return message;
  },
};

function createBaseUpdateDeploymentTeamResponse(): UpdateDeploymentTeamResponse {
  return { team: undefined };
}

export const UpdateDeploymentTeamResponse = {
  encode(message: UpdateDeploymentTeamResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.team !== undefined) {
      Team.encode(message.team, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateDeploymentTeamResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateDeploymentTeamResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.team = Team.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateDeploymentTeamResponse {
    return { team: isSet(object.team) ? Team.fromJSON(object.team) : undefined };
  },

  toJSON(message: UpdateDeploymentTeamResponse): unknown {
    const obj: any = {};
    if (message.team !== undefined) {
      obj.team = Team.toJSON(message.team);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateDeploymentTeamResponse>, I>>(base?: I): UpdateDeploymentTeamResponse {
    return UpdateDeploymentTeamResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateDeploymentTeamResponse>, I>>(object: I): UpdateDeploymentTeamResponse {
    const message = createBaseUpdateDeploymentTeamResponse();
    message.team = (object.team !== undefined && object.team !== null) ? Team.fromPartial(object.team) : undefined;
    return message;
  },
};

function createBaseDeleteDeploymentTeamRequest(): DeleteDeploymentTeamRequest {
  return { deploymentId: 0, teamId: 0 };
}

export const DeleteDeploymentTeamRequest = {
  encode(message: DeleteDeploymentTeamRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    if (message.teamId !== 0) {
      writer.uint32(16).int64(message.teamId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteDeploymentTeamRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteDeploymentTeamRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.teamId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteDeploymentTeamRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      teamId: isSet(object.teamId) ? Number(object.teamId) : 0,
    };
  },

  toJSON(message: DeleteDeploymentTeamRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.teamId !== 0) {
      obj.teamId = Math.round(message.teamId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteDeploymentTeamRequest>, I>>(base?: I): DeleteDeploymentTeamRequest {
    return DeleteDeploymentTeamRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteDeploymentTeamRequest>, I>>(object: I): DeleteDeploymentTeamRequest {
    const message = createBaseDeleteDeploymentTeamRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.teamId = object.teamId ?? 0;
    return message;
  },
};

function createBaseDeleteDeploymentTeamResponse(): DeleteDeploymentTeamResponse {
  return {};
}

export const DeleteDeploymentTeamResponse = {
  encode(_: DeleteDeploymentTeamResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteDeploymentTeamResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteDeploymentTeamResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteDeploymentTeamResponse {
    return {};
  },

  toJSON(_: DeleteDeploymentTeamResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteDeploymentTeamResponse>, I>>(base?: I): DeleteDeploymentTeamResponse {
    return DeleteDeploymentTeamResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteDeploymentTeamResponse>, I>>(_: I): DeleteDeploymentTeamResponse {
    const message = createBaseDeleteDeploymentTeamResponse();
    return message;
  },
};

export interface PermissionsService {
  checkRbacStatus(request: CheckRbacStatusRequest): Promise<CheckRbacStatusResponse>;
  setRbacStatus(request: SetRbacStatusRequest): Promise<SetRbacStatusResponse>;
  listDeploymentTeams(request: ListDeploymentTeamsRequest): Promise<ListDeploymentTeamsResponse>;
  createDeploymentTeam(request: CreateDeploymentTeamRequest): Promise<CreateDeploymentTeamResponse>;
  getDeploymentTeam(request: GetDeploymentTeamRequest): Promise<GetDeploymentTeamResponse>;
  updateDeploymentTeam(request: UpdateDeploymentTeamRequest): Promise<UpdateDeploymentTeamResponse>;
  deleteDeploymentTeam(request: DeleteDeploymentTeamRequest): Promise<DeleteDeploymentTeamResponse>;
}

export const PermissionsServiceServiceName = "protos.permissions.v2.PermissionsService";
export class PermissionsServiceClientImpl implements PermissionsService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || PermissionsServiceServiceName;
    this.rpc = rpc;
    this.checkRbacStatus = this.checkRbacStatus.bind(this);
    this.setRbacStatus = this.setRbacStatus.bind(this);
    this.listDeploymentTeams = this.listDeploymentTeams.bind(this);
    this.createDeploymentTeam = this.createDeploymentTeam.bind(this);
    this.getDeploymentTeam = this.getDeploymentTeam.bind(this);
    this.updateDeploymentTeam = this.updateDeploymentTeam.bind(this);
    this.deleteDeploymentTeam = this.deleteDeploymentTeam.bind(this);
  }
  checkRbacStatus(request: CheckRbacStatusRequest): Promise<CheckRbacStatusResponse> {
    const data = CheckRbacStatusRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CheckRbacStatus", data);
    return promise.then((data) => CheckRbacStatusResponse.decode(_m0.Reader.create(data)));
  }

  setRbacStatus(request: SetRbacStatusRequest): Promise<SetRbacStatusResponse> {
    const data = SetRbacStatusRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetRbacStatus", data);
    return promise.then((data) => SetRbacStatusResponse.decode(_m0.Reader.create(data)));
  }

  listDeploymentTeams(request: ListDeploymentTeamsRequest): Promise<ListDeploymentTeamsResponse> {
    const data = ListDeploymentTeamsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ListDeploymentTeams", data);
    return promise.then((data) => ListDeploymentTeamsResponse.decode(_m0.Reader.create(data)));
  }

  createDeploymentTeam(request: CreateDeploymentTeamRequest): Promise<CreateDeploymentTeamResponse> {
    const data = CreateDeploymentTeamRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CreateDeploymentTeam", data);
    return promise.then((data) => CreateDeploymentTeamResponse.decode(_m0.Reader.create(data)));
  }

  getDeploymentTeam(request: GetDeploymentTeamRequest): Promise<GetDeploymentTeamResponse> {
    const data = GetDeploymentTeamRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetDeploymentTeam", data);
    return promise.then((data) => GetDeploymentTeamResponse.decode(_m0.Reader.create(data)));
  }

  updateDeploymentTeam(request: UpdateDeploymentTeamRequest): Promise<UpdateDeploymentTeamResponse> {
    const data = UpdateDeploymentTeamRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "UpdateDeploymentTeam", data);
    return promise.then((data) => UpdateDeploymentTeamResponse.decode(_m0.Reader.create(data)));
  }

  deleteDeploymentTeam(request: DeleteDeploymentTeamRequest): Promise<DeleteDeploymentTeamResponse> {
    const data = DeleteDeploymentTeamRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "DeleteDeploymentTeam", data);
    return promise.then((data) => DeleteDeploymentTeamResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

declare const self: any | undefined;
declare const window: any | undefined;
declare const global: any | undefined;
const tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new tsProtoGlobalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
